/**
 * Error codes related to Mobile API Service Response
 *
 **/

export enum ErrorCodes {
    INVALID_PWD = 4001,
    INCORRECT_USERNAME_OR_PWD = 4002,
    TEMP_PWD_EXPIRED = 4007,
    INCORRECT_PWD = 4011,
    ACCOUNT_LCK = 4017,
    /** Auth0 passwordless SMS send failed (invalid/unreachable number); aligns with CX Auth0AuthenticationFailed */
    AUTH0_AUTHENTICATION_FAILED = 4046,
    /** Auth0 passwordless signup blocked (duplicate / policy); aligns with ServiceErrorCode.Auth0SignupNotAllowed */
    AUTH0_SIGNUP_NOT_ALLOWED = 4050,
    /** CX sliding-window limit on passwordless (identify already passed); value.retryAfterSeconds optional */
    CIAM_OTP_CX_RATE_LIMIT = 4055,
    /** Auth0 / passwordless token endpoint rate or abuse limit */
    CIAM_OTP_PROVIDER_RATE_LIMIT = 4056,
    CIAM_AUTH0_OTP_INVALID_CODE = 4063,
    CIAM_AUTH0_OTP_EXPIRED = 4064,
    CIAM_AUTH0_OTP_PER_CODE_MAX = 4065,
    CIAM_AUTH0_OTP_ACCOUNT_LOCKED = 4066,
    CIAM_AUTH0_OTP_GENERIC = 4067,
    FACEBOOK_EMAIL_REQUIRED = 4068,
}
